import { Typography } from 'antd';
import React from 'react';

import HelmetWrapper from 'components/atoms/HelmetWrapper';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import DefaultPageHeader from 'components/composites/DefaultPageHeader';
import FarmbotIcon from 'components/icons/FarmbotIcon';

import './styles.less';

export default function SiteUnderMaintenance() {
  return (
    <>
      <HelmetWrapper section="Site Under Management" />
      <DefaultPageHeader title="" />
      <PageHeaderPusher>
        <div className="PageNotFound">
          <FarmbotIcon style={{ height: 52, marginBottom: 24 }} />
          <Typography.Title level={4}>
            Our site is currently under maintenance. Apologies for any inconvenience. We will be back soon.
          </Typography.Title>
        </div>
      </PageHeaderPusher>
    </>
  );
}
